import React, { Component, PropTypes } from 'react';
import update from 'react-addons-update';
import { canUseDOM } from 'exenv';

// TODO refactor cx to classnames
import cx from 'classnames';

import MobileLocationMenu from './menus/MobileLocationMenu';
import DesktopLocationMenu from './menus/DesktopLocationMenu';
import FavoritesMenu from './menus/FavoritesMenu';
import AccountMenu from './menus/AccountMenu';
import SupportMenu from './menus/SupportMenu';
import PaymentWarningBanner from '../PaymentWarningBanner/PaymentWarningBanner';

import config from '../../config';
import logoMobile from './logo_mobile.png';
import logoDesktop from './logo_desktop.png';

const navHeight = 50; // px
const sideNavWidth = 64; // px

class GlobalHeader extends Component {

  static propTypes = {
    locations: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    doClickedSubscribeCTA: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.locations = props.locations;
    // this.user = props.user || this.reloadUserData();
    this.user = props.user;
    this.config = config;
    this.analytics = this.props.analytics;

    this.state = {
      favorites: this.props.favorites || this.props.user.favorites,
      menu: {
        mobileOpen: false,
      },
      dim: {
        height: navHeight,
        secondaryWidth: 0,
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(update(this.state, {
      favorites: { $set: nextProps.favorites },
    }));
  }

  // reloadUserData() {
  //   if (canUseDOM && window.user_settings) {
  //     this.user = window.user_settings;
  //   }
  //   return this.user;
  // }

  closeMenu() {
    this.setState(update(this.state,
      { $set: { menu: {
        mobileOpen: false,
      },
        dim: {
          height: navHeight,
          secondaryWidth: 0,
        } } },
    ));
    this.body.style.display = 'block';
  }

  toggleMenu() {
    this.setState(update(this.state,
      { $set: { menu: {
        mobileOpen: !this.state.menu.mobileOpen,
        activeSubMenu: <FavoritesMenu favorites={this.state.favorites} user={this.user} mobile />,
        activeRef: 'favoritesMenu',
      } } },
    ));

    if (!this.state.menu.mobileOpen) { // the menu is open after the state has changed
      this.sizeMenu();
    }

    this.body.style.display = !this.state.menu.mobileOpen ? 'none' : 'block';
  }

  componentDidMount() {
    this.body = document.getElementById('main');
  }

  componentWillUnmount() {
  }

  sizeMenu() {
    this.setState(update(this.state,
      { $set: { dim: {
        secondaryWidth: window.innerWidth - sideNavWidth,
        height: window.innerHeight,
      } } },
    ));
  }

  closeDesktopMenu() {
    this.setState(update(this.state,
      { $set: { menu: {} } },
    ));
  }

  /**
   * Available menus
   *  - locationMenu
   *  - favoritesMenu
   *  - supportMenu
   *  - accountMenu
   *
   */
  loadMenu(menu, component) {
    if (!this.state.menu.mobileOpen) { // this is a good way to check if a desktop menu is open
      if (menu === this.state.menu.activeRef) { // close menu
        this.closeDesktopMenu();
        event.preventDefault();
        return;
      }

      document.addEventListener('click', (event) => {
        const eventTag = event.target.tagName.toLowerCase();
        const whitelist = ['i', 'a', 'span'];

        if (whitelist.indexOf(eventTag) < 0) {
          this.closeDesktopMenu();
          event.preventDefault();
        }
      }, false);
    }

    this.setState(update(this.state,
      { $set: { menu: {
        mobileOpen: this.state.menu.mobileOpen,
        activeSubMenu: component,
        activeRef: menu,
      } } },
    ));

    event.preventDefault();
  }

  getMenuClasses(menu) {
    return (menu === this.state.menu.activeRef) ? 'dropdown-toggle active' : 'dropdown-toggle';
  }

  getOpen(menu) {
    return (menu === this.state.menu.activeRef) ? 'dropdown active' : 'dropdown';
  }

  exitLink(path) {
    const destination = canUseDOM ? window.location.pathname : '/';
    return `${path}?destination=${destination}`;
  }

  clickedTryPremium = () => {
    const {
      doClickedSubscribeCTA,
    } = this.props;
    doClickedSubscribeCTA({
      ctaLocation: 'navigation header',
    });
  }

  clickedSignIn = () => {}

  clickedRenew = () => {}

  clickedHome = () => {
    window.location.href = '/';
  }

  render() {
    const navClasses = cx({
      'navbar-collapse': true,
      'collapse.in': this.state.menu.mobileOpen,
      collapse: !this.state.menu.mobileOpen,
    });

    const hamburgerClasses = cx({
      'icon-menu': !this.state.menu.mobileOpen,
      'icon-close': this.state.menu.mobileOpen,
      hamburger: true,
    });

    return (
      <div className="container-fluid">
        <header className="navbar navbar-fixed-top" id="top" role="banner">
          {this.user.type === 'premium' && this.user.warningType ? <PaymentWarningBanner warningType={this.user.warningType} /> : null}
          <div className="container">
            <div className="navbar-header">
              <button
                onClick={this.toggleMenu.bind(this)}
                type="button"
                className="navbar-toggle collapsed"
              >
                <span className="sr-only">Toggle navigation</span>
                <i className={hamburgerClasses} />
              </button>
              <a onClick={this.clickedHome} href="/">
                <img className="brand touch" src={`${logoMobile}`} alt="Buoyweather" />
                <img className="brand desktop" src={`${logoDesktop}`} alt="Buoyweather" />
              </a>
            </div>
            <nav
              className={navClasses}
              style={{ height: this.state.dim.height }} ref="navContainer"
            >
              <ul
                className="nav navbar-nav navbar-right"
                ref="navTopLevel"
                style={{ height: this.state.dim.height }}
              >
                {(() => {
                  if (this.user.type === 'expired') {
                    return (
                      <li className="desktop">
                        <a
                          onClick={this.clickedRenew}
                          href={this.config.links.funnel.renew}
                          className="btn btn-success"
                        >
                        Renew Membership Now
                      </a>
                      </li>
                    );
                  }
                })()}
                {(() => {
                  if (this.user.type === 'registered') {
                    return (
                      <li className="desktop">
                        <a
                          onClick={this.clickedTryPremium}
                          href={this.config.links.funnel.try_premium}
                          className="btn btn-success"
                        >
                        Try Premium Free Now
                      </a>
                      </li>
                    );
                  }
                })()}

                {(() => {
                  if (this.user.user_id > 0 || (this.state.menu.mobileOpen)) {
                    return (
                      <li className={this.getOpen('favoritesMenu')}>
                        <a
                          href="#" ref="favoritesMenu"
                          className={this.getMenuClasses('favoritesMenu')}
                          onClick={this.loadMenu.bind(this, 'favoritesMenu', <FavoritesMenu favorites={this.state.favorites} mobile user={this.user} />)}
                        >
                          <i className="icon-star" /><span>Favorites</span>
                        </a>
                        {/* <MenuCaret activeMenu={this.state.menu.activeRef} menu="favoritesMenu" /> */}
                        <FavoritesMenu favorites={this.state.favorites} user={this.user} openRef={this.state.menu.activeRef} />
                      </li>
                    );
                  }
                })()}
                <li className={`${this.getOpen('locationMenu')} locationMenu`}>
                  <a
                    href="#" ref="locationMenu"
                    className={this.getMenuClasses('locationMenu')}
                    onClick={this.loadMenu.bind(this, 'locationMenu', <MobileLocationMenu locations={this.locations} mobile closeMenu={this.closeMenu.bind(this)} />)}
                  >
                    <i className="icon-crosshairs" /><span>Locations</span>
                  </a>
                  {/* <MenuCaret activeMenu={this.state.menu.activeRef} menu="locationMenu" /> */}
                  <DesktopLocationMenu locations={this.locations} openRef={this.state.menu.activeRef} />
                </li>
                {(() => {
                  if (this.user.user_id && this.user.user_id > 0) {
                    return (
                      <li className={this.getOpen('accountMenu')}>
                        <a
                          href="#" ref="accountMenu"
                          className={this.getMenuClasses('accountMenu')}
                          onClick={this.loadMenu.bind(this, 'accountMenu', <AccountMenu mobile user={this.user} />)}
                        >
                          {(() => {
                            if (this.user.type === 'expired') {
                              return <i className="fa fa-exclamation-triangle" />;
                            }
                            return <i className="icon-account" />;
                          })()}
                          <span>Account</span>
                        </a>
                        {/* <MenuCaret activeMenu={this.state.menu.activeRef} menu="accountMenu" /> */}
                        <AccountMenu openRef={this.state.menu.activeRef} user={this.user} />
                      </li>
                    );
                  }
                })()}
                <li className={`${this.getOpen('locationMenu')} touch`}>
                  <a
                    href="#" ref="supportMenu"
                    className={this.getMenuClasses('supportMenu')}
                    onClick={this.loadMenu.bind(this, 'supportMenu', <SupportMenu mobile />)}
                  >
                    <i className="fa fa-support" /><span>Support</span>
                  </a>
                  <SupportMenu openRef={this.state.menu.activeRef} />
                </li>
                {(() => {
                  if (this.user.type === 'non-registered') {
                    return (
                      <li className="desktop">
                        <a
                          onClick={this.clickedSignIn}
                          href={this.exitLink(this.config.links.funnel.login)}
                          className="btn btn-primary"
                        >
                        Sign In
                      </a>
                      </li>
                    );
                  }
                })()}
                {(() => {
                  if (this.user.type === 'non-registered') {
                    return (
                      <li className="desktop">
                        <a
                          onClick={this.clickedTryPremium}
                          href={this.config.links.funnel.try_premium}
                          className="btn btn-success"
                        >
                        Try Premium Free Now
                      </a>
                      </li>
                    );
                  }
                })()}
              </ul>
              <div
                id="mobile-menu" ref="navSecondary"
                style={{ height: this.state.dim.height, width: this.state.dim.secondaryWidth }}
              >
                <div
                  className="mobile-menu-container"
                  style={{ height: (this.state.dim.height - 65) }}
                >
                  {(() => this.state.menu.activeSubMenu)()}
                </div>
              </div>
            </nav>
          </div>
        </header>
      </div>
    );
  }
}

GlobalHeader.defaultProps = {
  user: {
    user_id: -1,
    ip: '0.0.0.0',
    favorites: [],
    units: 'e',
    type: 'non-registered',
  },
};


class MenuCaret extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const menus = cx({
      fa: true,
      'fa-caret-up': true,
      active: this.props.menu === this.props.activeMenu,
    });

    return (
      <span className="caret-holder"><i className={menus} /></span>
    );
  }
}

export default GlobalHeader;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/GlobalHeader.js